import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { useSeo } from "../hooks/useSeo";

export default function Diensten() {
  const { t, lang } = useI18n();
  useSeo({ title: t.seo.services.title, description: t.seo.services.description, path: "/diensten", lang });
  return (
    <section className="container-wide py-16 md:py-24">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow">{t.editorial.servicesIndexLabel}</p>
          <h1 className="mt-5 text-4xl md:text-5xl lg:text-7xl tracking-[-0.025em] font-medium text-foreground leading-[1.02]">
            {t.services.title}
          </h1>
        </div>
        <div className="lg:col-span-5 lg:text-right">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl lg:ml-auto">
            {t.services.lead}
          </p>
        </div>
      </div>

      <ol className="mt-16 border-t border-border" data-testid="services-grid">
        {t.services.items.map((item, i) => (
          <li
            key={i}
            className="group grid md:grid-cols-12 gap-6 py-8 md:py-10 border-b border-border items-baseline transition-colors hover:bg-secondary/30"
            data-testid={`service-${i}`}
          >
            <div className="md:col-span-1">
              <span className="font-display text-3xl text-accent leading-none">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <div className="md:col-span-4">
              <h3 className="text-2xl md:text-3xl text-foreground tracking-tight leading-snug">{item.title}</h3>
            </div>
            <div className="md:col-span-6">
              <p className="text-muted-foreground leading-relaxed max-w-xl">{item.body}</p>
            </div>
            <div className="md:col-span-1 md:text-right">
              <Link
                to="/contact?intent=intake"
                className="inline-flex h-9 w-9 rounded-full border border-border items-center justify-center text-foreground/70 group-hover:border-accent group-hover:text-accent transition-colors"
                aria-label={`Aanvragen — ${item.title}`}
              >
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-16 grid md:grid-cols-12 gap-6 border-t border-border pt-10">
        <div className="md:col-span-7">
          <p className="font-display text-2xl md:text-3xl text-foreground tracking-[-0.015em] leading-snug">
            {t.editorial.servicesCtaText} <span className="italic text-primary">{t.editorial.servicesCtaHighlight}</span>
          </p>
        </div>
        <div className="md:col-span-5 flex md:justify-end items-center gap-4">
          <Link to="/contact?intent=intake" className="btn-primary" data-testid="services-cta-primary">
            {t.nav.requestSearch} <ArrowUpRight className="h-4 w-4" />
          </Link>
          <Link to="/tarieven" className="btn-ghost hidden md:inline-flex" data-testid="services-cta-secondary">
            {t.home.seePricing}
          </Link>
        </div>
      </div>
    </section>
  );
}
